"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerseFarmController = void 0;
var ethers_1 = require("ethers");
var utils_1 = require("ethers/lib/utils");
var VerseStaking_1 = require("../../contracts/VerseStaking");
var farmsData_1 = __importDefault(require("../../data/farmsData"));
var Result_1 = __importDefault(require("../../Result"));
/**
 * All the farming contract methods and helpers
 */
var VerseFarmController = /** @class */ (function () {
    function VerseFarmController(signer, farmContract) {
        this._signer = signer;
        this._stakingContract = new ethers_1.Contract(farmContract, new utils_1.Interface(VerseStaking_1.ABI), this._signer);
    }
    /**
     * Get a list of farms from FarmsData
     *
     * @param showHidden include farms that are hidden
     * @returns IFarmPair[] - list of farm pairs
     */
    VerseFarmController.getFarmsData = function (showHidden) {
        var filteredFarmsData = farmsData_1.default.filter(function (farm) { return (showHidden ? true : !(farm === null || farm === void 0 ? void 0 : farm.hidden)); });
        return Result_1.default.ok(filteredFarmsData);
    };
    /**
     * Deposit amount into staking contract
     *
     * @param amount Amount to deposit
     * @returns string - transaction hash
     */
    VerseFarmController.prototype.farmDeposit = function (amount_1) {
        return __awaiter(this, arguments, void 0, function (amount, overrides) {
            var transaction, error_1;
            if (overrides === void 0) { overrides = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._stakingContract.farmDeposit(amount, overrides)];
                    case 1:
                        transaction = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(transaction)];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(error_1.message)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Withdraw set amount from farm
     *
     * @param amount BigNumber - amount to withdrawe. Exits farm if undefined
     * @returns string - transaction hash
     */
    VerseFarmController.prototype.withdraw = function (amount_1) {
        return __awaiter(this, arguments, void 0, function (amount, overrides) {
            var transaction, error_2;
            if (overrides === void 0) { overrides = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._stakingContract.farmWithdraw(amount, overrides)];
                    case 1:
                        transaction = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(transaction)];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(error_2.message)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Removes all rewards and farm deposits from farm
     *
     * @returns ContractTransaction
     */
    VerseFarmController.prototype.exitFarm = function () {
        return __awaiter(this, arguments, void 0, function (overrides) {
            var transaction, error_3;
            if (overrides === void 0) { overrides = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._stakingContract.exitFarm(overrides)];
                    case 1:
                        transaction = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(transaction)];
                    case 2:
                        error_3 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(error_3.message)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Claims farm rewards
     *
     * @returns ContractTransaction
     */
    VerseFarmController.prototype.claimReward = function () {
        return __awaiter(this, arguments, void 0, function (overrides) {
            var transaction, error_4;
            if (overrides === void 0) { overrides = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._stakingContract.claimReward(overrides)];
                    case 1:
                        transaction = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(transaction)];
                    case 2:
                        error_4 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(error_4.message)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets reward rate
     *
     * @returns BigNumber
     */
    VerseFarmController.prototype.rewardRate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var transaction, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._stakingContract.rewardRate()];
                    case 1:
                        transaction = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(transaction)];
                    case 2:
                        error_5 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(error_5.message)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets total supply
     *
     * @returns BigNumber
     */
    VerseFarmController.prototype.totalSupply = function () {
        return __awaiter(this, void 0, void 0, function () {
            var transaction, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._stakingContract.totalSupply()];
                    case 1:
                        transaction = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(transaction)];
                    case 2:
                        error_6 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(error_6.message)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Estimates gas cost of farms deposit
     *
     * @param amount Amount to deposit
     * @returns BigNumber
     */
    VerseFarmController.prototype.estimateGasFarmDeposit = function (amount) {
        return __awaiter(this, void 0, void 0, function () {
            var gasUnits, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._stakingContract.estimateGas.farmDeposit(amount)];
                    case 1:
                        gasUnits = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(gasUnits)];
                    case 2:
                        error_7 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(error_7.message)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Estimates gas cost of farms withdraw
     *
     * @param amount BigNumber - amount to withdraw. Exits farm if undefined
     * @returns BigNumber
     */
    VerseFarmController.prototype.estimateGasFarmWithdraw = function (amount) {
        return __awaiter(this, void 0, void 0, function () {
            var gasUnits, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._stakingContract.estimateGas.farmWithdraw(amount)];
                    case 1:
                        gasUnits = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(gasUnits)];
                    case 2:
                        error_8 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(error_8.message)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Estimates gas cost of farms exit
     *
     * @returns BigNumber
     */
    VerseFarmController.prototype.estimateGasExitFarm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var gasUnits, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._stakingContract.estimateGas.exitFarm()];
                    case 1:
                        gasUnits = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(gasUnits)];
                    case 2:
                        error_9 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(error_9.message)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Estimates gas cost of farms claim reward
     *
     * @returns BigNumber
     */
    VerseFarmController.prototype.estimateGasClaimReward = function () {
        return __awaiter(this, void 0, void 0, function () {
            var gasUnits, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._stakingContract.estimateGas.claimReward()];
                    case 1:
                        gasUnits = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(gasUnits)];
                    case 2:
                        error_10 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(error_10.message)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return VerseFarmController;
}());
exports.VerseFarmController = VerseFarmController;
